import { Button, Card, Chip, Divider, Icons, Stack, Typography } from '@healthinal/ui';
import { useState } from 'react';
import { TherapyDto } from '../../../../../api/generated/model';
import {
  getGetIsolationByPatientQueryKey,
  useGetIsolationByPatientSuspense,
} from '../../../../../api/generated/patient-controller/patient-controller.ts';
import { formatDateWithGermanMonth } from '../../../../../utils/date.ts';
import { EndPatientAddressDialog } from '../../../../components/patient-address/EndPatientAddressDialog.tsx';
import { PatientAddressDisplay } from '../../../../components/patient-address/PatientAddressDisplay.tsx';
import { CreateIsolationDialog } from './CreateIsolationDialog.tsx';

export function IsolationCard({ patientId, therapy }: { patientId: string; therapy?: TherapyDto }) {
  const { data: isolation } = useGetIsolationByPatientSuspense(patientId);
  const [isCreateIsolationDialogOpen, setIsCreateIsolationDialogOpen] = useState(false);
  const [isEndPatientAddressDialogOpen, setIsEndPatientAddressDialogOpen] = useState(false);

  return (
    <>
      <Card>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <Stack gap={1}>
            <Typography level="title-lg">Isolation</Typography>
            {!isolation ? (
              <Chip>Nicht isoliert</Chip>
            ) : (
              <Chip
                color={'success'}
                variant={'solid'}
                endDecorator={<Icons.Edit />}
                onClick={() => setIsEndPatientAddressDialogOpen(true)}>
                Isoliert
              </Chip>
            )}
          </Stack>
          {!therapy?.finished && (
            <Button color={'neutral'} onClick={() => setIsCreateIsolationDialogOpen(true)}>
              Isolation erfassen
            </Button>
          )}
        </Stack>
        {isolation && <Divider />}
        {isolation && (
          <Stack gap={2}>
            <Stack direction={'row'} alignItems={'center'}>
              <Typography flex={1} level={'title-md'}>
                Isoliert
              </Typography>
              <Typography flex={3} level={'title-sm'}>
                {formatDateWithGermanMonth(isolation.from)} - {formatDateWithGermanMonth(isolation.until) ?? 'Jetzt'}
              </Typography>
            </Stack>
            <Stack direction={'row'}>
              <Typography flex={1} level={'title-md'}>
                Ort
              </Typography>
              <PatientAddressDisplay flex={3} patientAddress={isolation} />
            </Stack>
          </Stack>
        )}
      </Card>
      <CreateIsolationDialog
        patientId={patientId}
        open={isCreateIsolationDialogOpen}
        onClose={() => setIsCreateIsolationDialogOpen(false)}
      />
      {isolation && (
        <EndPatientAddressDialog
          open={isEndPatientAddressDialogOpen}
          onClose={() => setIsEndPatientAddressDialogOpen(false)}
          patientAddress={isolation}
          modalTitle={'Isolation'}
          queryKeyToInvalidate={getGetIsolationByPatientQueryKey(patientId)}
        />
      )}
    </>
  );
}
